module.exports = __webpack_public_path__ + "media/images/flags/16/Guam-6fe141c0fa400617fae1242eb2306101.png";